
import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ROUTES_URL } from '@app/core';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs/internal/Observable';
import { AlertService, DialogService } from 'shared';
import { InfoDatosBdContainerActions as ContainerActions } from '../store/info-datos.actions';
import { InfoDatosContainerModel } from '../store/info-datos.model';
import { INFO_DATOS_BD_STATE_TOKEN as CONTAINER_STATE_TOKEN } from '../store/states/info-datos.state';
import { MESSAGES } from '../_utils/messages';

@Component({
  templateUrl: './info-datos.component.html',
  styleUrls: ['./info-datos.component.scss']
})
export class InfoDatosComponent implements OnInit {

  @Select(CONTAINER_STATE_TOKEN) state$: Observable<InfoDatosContainerModel>;



  constructor(
    private store: Store,
    private alertService: AlertService,
    private router: Router,

  ) { }

  ngOnInit(): void {
  }

  handleClickNuevo = () => {

  }

  handleClickEdit = (item: any /*usar type*/) => {

  }

  handleClickDelete = (item: any /*usar type*/) => {
    this.alertService.confirm(MESSAGES.CONFIRM_ELIMINAR).subscribe(result => {
      if (result.confirm) {
      }
    });
  }




}